import React, { useState } from "react";
import { connect } from "react-redux";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardHeader, CardBody, Row, Col, BreadcrumbItem, Breadcrumb } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import qs from "query-string";

import ProjectTwrCategoriesIndex from "modules/project/twr/categories/web/index";
import ProjectTwrEsmCategoriesIndex from "modules/project/twr/esm_categories/web/index";

function mapStateToProps(state) {
  return {
    current_project_id: state.current_user?.current_project_id,
  };
}

const TwrSettingsIndex = (props) => {
  const { location, history, current_project_id } = props;
  const query = qs.parse(location.search);
  const { tab } = query;

  const [activeTab, setActiveTab] = useState((typeof tab === "string" ? tab : null) || "categories");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Card>
      <Breadcrumb dcrumb>
        <BreadcrumbItem active>
          {current_project_id && (
            <Link to={`/project/${current_project_id}/twrs`} >
              Project TWRs
            </Link>
          )}
        </BreadcrumbItem>

        <BreadcrumbItem active>Temporary Works Register Settings</BreadcrumbItem>
      </Breadcrumb>
      <CardHeader>
        <h3>Temporary Works Register Settings</h3>
      </CardHeader>
      <CardBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "categories" })}
              onClick={() => {
                toggle("categories");
                history.push("/project/twr/settings?tab=categories");
              }}
            >
              Categories
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "esm_categories" })}
              onClick={() => {
                toggle("esm_categories");
                history.push("/project/twr/settings?tab=esm_categories");
              }}
            >
              ESM Categories
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="categories">
            <ProjectTwrCategoriesIndex {...props} />
          </TabPane>
          <TabPane tabId="esm_categories">
            <ProjectTwrEsmCategoriesIndex {...props} />
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  );
};

export default connect(mapStateToProps)(TwrSettingsIndex);
